import React from 'react';

export default function ContactSection() {



  const contactInfo = [
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      ),
      label: 'Email',
      value: 's2023101508@firstasia.edu.ph',
      href: 'https://mail.google.com/mail/?view=cm&to=s2023101508@firstasia.edu.ph',
      color: '#ea4335',
    },
    {
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      ),
      label: 'Phone',
      value: '09816845961',
      href: 'tel:+6309816845961',
      color: '#00f2fe',
    },
  ];

  const socialLinks = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
          <rect x="2" y="9" width="4" height="12"/>
          <circle cx="4" cy="4" r="2"/>
        </svg>
      ),
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/in/jhon-jeremie-baita-4b9331357/',
      color: '#0a66c2',
      username: 'Jhon Jeremie Baita',
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
        </svg>
      ),
      label: 'GitHub',
      href: 'https://github.com/101604',
      color: '#8b5cf6',
      username: '101604',
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
        </svg>
      ),
      label: 'Facebook',
      href: 'https://www.facebook.com/jbaita.16/',
      color: '#1877f2',
      username: 'jbaita.16',
    },
  ];

  return (
    <section id="contact" className="section section-alt">
      <div className="section-content">
        <h2 className="section-title">Get In Touch</h2>
        <p className="contact-subtitle">
          Have a project in mind or just want to say hi? I'd love to hear from you!
        </p>

        <div className="contact-wrapper">
          <div className="contact-info-column">
            {/* Direct Contact Cards */}
            <div className="contact-direct-cards">
              {contactInfo.map((item, i) => (
                <a
                  key={i}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-info-card"
                  style={{ '--card-accent': item.color }}
                >
                  <div className="contact-info-card-icon">
                    {item.icon}
                  </div>
                  <div className="contact-info-card-text">
                    <span className="contact-info-card-label">{item.label}</span>
                    <span className="contact-info-card-value">{item.value}</span>
                  </div>
                  <div className="contact-info-card-arrow">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M7 17l9.2-9.2M17 17V7H7"/>
                    </svg>
                  </div>
                </a>
              ))}
            </div>

            {/* Social Links */}
            <div className="contact-social-section">
              <h3 className="contact-social-heading">
                <span className="contact-social-line"></span>
                Connect with me
                <span className="contact-social-line"></span>
              </h3>
              <div className="contact-social-cards">
                {socialLinks.map((social, i) => (
                  <a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-social-card"
                    style={{ '--social-color': social.color, animationDelay: `${i * 0.1}s` }}
                  >
                    <div className="contact-social-icon-wrapper">
                      {social.icon}
                    </div>
                    <div className="contact-social-info">
                      <span className="contact-social-label">{social.label}</span>
                      <span className="contact-social-username">@{social.username}</span>
                    </div>
                    <div className="contact-social-hover-arrow">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M7 17l9.2-9.2M17 17V7H7"/>
                      </svg>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Availability Badge */}
            <div className="contact-availability">
              <span className="contact-availability-dot"></span>
              <span>Currently available for freelance & collaboration</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
